<res-base-modal [modalTitle]="modalTitle" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId"
    [primaryButtonLabel]="primaryButtonLabel" (primaryButtonActionEmt)="submit()" (closeButtonActionEmt)="closeModal()"
    [secondaryButtonLabel]="secondaryButtonLabel" [isPrimaryBtnEnabled]=true [modalHelpIndex]="helpIndex">

    <div class="main-container">
        <res-custom-checkbox [automationId]="modalAutomationId + '-top-level-clusters-checkbox'" disabled="true"
            [ngModel]="true" [content]="topLevelCheckboxLabel" *ngIf="!isBuildSubclustersMode">
        </res-custom-checkbox>
        <div class="subcluster-levels-container">
            <res-custom-checkbox [automationId]="modalAutomationId + '-subcluster-levels-checkbox'"
                [(ngModel)]="subclusterLevelsChecked" content="Subcluster Levels:" *ngIf="!isBuildSubclustersMode">
            </res-custom-checkbox>
            <label [automationId]="modalAutomationId + '-subcluster-levels-label'"
                *ngIf="isBuildSubclustersMode">Subcluster Levels:</label>
            <res-custom-input class="levels-input" [field]="noOfLevels" [inputType]="'number'"
                [inputNumberMaxLength]="2" [automationId]="modalAutomationId + '-subcluster-levels-input'"
                [hideClearBtn]="true" [inputNumberMinValue]="1" [inputNumberMaxValue]="10">
            </res-custom-input>
            <span class="range-span">(1-10)</span>
        </div>
    </div>
</res-base-modal>